import React, { memo } from 'react';
import classes from './service-logo-list.module.scss';
import { ServiceList } from 'components/templates/MyPageTemplate';

type Props = {
	serviceList: ServiceList[];
};

// サービスサイトのロゴ一覧表示
export const ServiceLogoList = memo((props: Props) => {
	const { serviceList } = props;

	// ロゴを3個ずつ表示
	const listSize = 3;
	const splitList = (list, size) => {
		return Array.from({ length: Math.ceil(list.length / size) }, (_, index) =>
			list.slice(index * size, ++index * size),
		);
	};
	const splitServiceList = splitList(serviceList, listSize);

	return (
		<div className="service-list">
			{splitServiceList.map((service, groupIndex) => {
				return (
					<ul key={groupIndex}>
						{service.map((item, index) => {
							return (
								<li>
									<a href={item.url} target="_blank">
										<img src={item.logoPath} alt="" />
										<h4>{item.serviceName}</h4>
										<div className="lead-txt">{item.textMessage}</div>
									</a>
								</li>
							);
						})}
					</ul>
				);
			})}
		</div>
	);
});
